module.exports = __webpack_public_path__ + "img/predio.bf33fd5c.png";